<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">CLIMB</p>
<p class="chap_line"></p>
<p class="center"><span class="big">W</span>hen you own the most glorious kingdom ever known, that transcends all space and time</p>
<p class="center">lt is right and fair to require a code of ethics and/honor before you get the reward of using the Golden Stairs to Heaven’s front door climb.</p>
<p class="center1">God only has two set of stairs for all of humanity Universe spanning</p>
<p class="center">And one leads up and the other leads down but only one requires prayerful sacrifice and dedicated planning.</p>
<p class="center">The outcome from the war in heaven clearly defines the dividing line between good and evil’s front line</p>
<p class="center">And it could not be more starkly defined that the consequences of evil are gore covered claws imbedded deep into your soul with screaming anguish dragging you to your cell of torturous confine.</p>
<p class="center">The jealous envy quickly becomes a raging hatred of God’s rewards for those that love God and follow his plan of salvation</p>
<p class="center">And the raging unending fury of unending deprivation.</p>
<p class="center">When you own the most glorious kingdom ever known, that transcends all space and time</p>
<p class="center">It is right and fair to require a code of ethics and honor before you get the reward of using the</p>
<p class="center">Golden Stairs to Heaven’s front door climb.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap003.vue?b834a8f2